import React from 'react'
import { findTarget } from '../../../../../utils/microcopy.utils'
import options from '../../../../../utils/richText.utils'
import { renderRichText } from '../../../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../../../utils/shortTextFormatting'
import Typography from '../../../../global/typography'
import { CardBody, CardFooter, CardHeader, CardHolder, CardSubHeader, RowItem } from './style'

const OfficeCard = (props: any) => {
  const { city, cityOverride, country, address, phone, email, contactSales, mapUrl, microcopy } =
    props

  return (
    <CardHolder data-cy="OfficeCard">
      <CardHeader data-cy="CardHeaderCity">
        {city && city.title && (
          <Typography type="header4">
            <label className="CardHeader__City">
              {cityOverride ? formatInlineCode(cityOverride) : formatInlineCode(city.title)}
            </label>
          </Typography>
        )}
        {mapUrl && mapUrl.mapUrl && microcopy && microcopy.values && (
          <Typography className="Link-MapUrl" type="bodyXS">
            <a href={mapUrl.mapUrl} target="_blank">
              {findTarget(`Map.text`, microcopy.values, false) || 'See map'}
            </a>
          </Typography>
        )}
      </CardHeader>

      {country && country.title && (
        <CardSubHeader data-cy="CardSubHeaderCountry">
          <Typography type="captionAlt">
            <label className="CardSubHeader__Country">{country.title}</label>
          </Typography>
        </CardSubHeader>
      )}
      <CardBody>
        <RowItem data-cy="rowAddress">
          {microcopy && microcopy.values && (
            <Typography type="captionAlt">
              <label className="RowItem-Name Address">
                {findTarget(`Address.text`, microcopy.values, false) || 'Address'}
              </label>
            </Typography>
          )}
          {address && address.address && (
            <Typography type="leadXS">
              <label className="RowItem-Content">{formatInlineCode(address.address)}</label>
            </Typography>
          )}
        </RowItem>
        {phone && (
          <RowItem data-cy="rowPhone">
            {microcopy && microcopy.values && (
              <Typography type="captionAlt">
                <label className="RowItem-Name Phone">
                  {findTarget(`Phone.text`, microcopy.values, false) || 'Phone'}
                </label>
              </Typography>
            )}

            <Typography type="leadXS">
              <label className="RowItem-Content">{renderRichText(phone, options)}</label>
            </Typography>
          </RowItem>
        )}
        {email && (
          <RowItem data-cy="rowEmail">
            {microcopy && microcopy.values && (
              <Typography type="captionAlt">
                <label className="RowItem-Name Email">
                  {findTarget(`Email.text`, microcopy.values, false) || 'Email'}
                </label>
              </Typography>
            )}
            {email && (
              <Typography type="leadXS">
                <label className="RowItem-Content">{renderRichText(email, options)}</label>
              </Typography>
            )}
          </RowItem>
        )}
      </CardBody>
      {contactSales && contactSales.externalUrl && contactSales.text && (
        <CardFooter data-cy="CardFooter">
          <Typography className="CardFooter__Link" type="label">
            <a href={contactSales.externalUrl}>{contactSales.text}</a>
          </Typography>
        </CardFooter>
      )}
    </CardHolder>
  )
}

export default OfficeCard
